/* 个人设计师和工作室优势 */
export const ADVANTAGE_LIST = {
  PERSONAL_DESIGNER: [
    '随时接单，时间自由，无数量要求',
    '签约秒批，告别等待',
    '合理定价，质高价高',
  ],
  WORD_ROOM: [
    '种类多样，适合各类设计团队',
    '每月打款，长期稳定获利',
    '根据质量定价，收益无上限',
  ],
}
/* 工作岗位导航 */
export const JOB_NAV = {
  LIST: [
    /*{
      title: '兔年设计',
      picList:[
        '/chao_origin_pic/22/09/26/f264d68a9f3bc2905d81f4cf5b91b19c.jpg',
        '/chao_origin_pic/22/09/29/f2f3417e5718e9d98b56c2de89233992.jpg',
        '/chao_origin_pic/22/10/19/45190b9c484f204e1725595e14a2a753.jpg',
        '/chao_origin_pic/22/09/16/40faa2e8126da62462fe9fcec6bff766.jpg',
      ]
    },*/
    {
      title: '3D',
      picList:[
        '/chao_origin_pic/22/06/30/ef61f1766461897b3d47d4fb66b11d19.jpg',
        '/chao_origin_pic/22/06/29/bbc8c5b1324a83ae04856b4e081bc857.jpg',
        '/chao_origin_pic/22/06/14/7fce7cfad8f8931b708be0da8aec4aa2.jpg',
        '/chao_origin_pic/22/06/09/f3bfb15619ec30256816164fce1f9ef8.jpg',
      ]
    },
    {
      title: '电商',
      picList:[
        '/chao_origin_pic/23/01/12/cfc67c1acde44d2dc30e83345b1a08f2.jpg',
        '/chao_origin_pic/22/10/05/c348838a4f66a78d28e6a649a883c985.jpg',
        '/chao_origin_pic/22/12/12/a5f544c04ceedf361857a0b04866dc7a.jpg',
        '/chao_origin_pic/22/10/20/fea2303203df2e5575e80480a1104f54.jpg',
      ]
    },
    {
      title: '创意海报',
      picList:[
        /* '/chao_origin_pic/22/07/08/e8c3395a468400e7f3cefc6c5308cd7c.jpg',
        '/chao_origin_pic/22/07/05/ae1fdece174b8549e5ff9ef199245466.jpg',
        '/chao_origin_pic/22/04/20/d0a017777b1fca56cf54acdee663bb5f.jpg',
        '/chao_origin_pic/22/05/09/c19ea61dc03ed129a324c511c21ed23e.jpg\n', */
        '/chao_origin_pic/23/02/16/85925becff16f515f6f80e3ad2fcc6d8.jpg',
        '/chao_origin_pic/23/05/04/de57b2a13b2845751b3c26fa3d46b4b9.jpg',
        '/chao_origin_pic/22/07/01/8acace339683d84905f41f88399892bc.jpg',
        '/chao_origin_pic/23/10/01/906f4c6df7c6f19f1d75f00abe4bdd0f.jpg',
      ]
    },
    {
      title: 'H5长图',
      picList:[
        '/chao_origin_pic/22/06/16/bb4c51c4588da16b1af993081c8aff97.jpg\n',
        '/chao_origin_pic/22/05/19/d270ef5972c471e7230f20f41f71e2ca.jpg',
        '/chao_origin_pic/22/05/06/50199f1280ba89a3b9393e3f43711bb6.jpg',
        '/chao_origin_pic/22/04/24/508f306633fb128e3a6c4ebd2e6a7037.jpg',
      ]
    },
    {
      title: '创意插画',
      picList:[
        '/chao_origin_pic/22/06/23/20f2311ac01d65efb0904f8ef1ad9bd9.jpg\n',
        '/chao_origin_pic/22/05/26/bd26cd7aa9858943c1f91932932eb4f1.jpg',
        '/chao_origin_pic/22/06/29/284895fe596023c30cb2b31aec704ac6.jpg\n',
        '/chao_origin_pic/22/05/23/f0c3de129ba9b9fab0112a08cf113c78.jpg',
      ]
    }
  ],
}

export const DESIGNER_STEP = [
  {
    label:"注册帐号，提交申请"
  },
  {
    label:"审核通过，签署协议"
  },
  {
    label:"开始创作，上传提交"
  },
  {
    label:"次月结算，收益入账"
  },
]
